import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cb23142&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb23142')) {
      api.createRecord('2cb23142', component.options)
    } else {
      api.reload('2cb23142', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cb23142&", function () {
      api.rerender('2cb23142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parse/3-2/index.vue"
export default component.exports